import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type BkPillColor = 'green' | 'blue' | 'red' | 'yellow' | 'purple' | 'neutral' | 'open' | 'active';

@Component({
  selector: 'bk-pill-badge',
  templateUrl: './bk-pill-badge.component.html',
  styleUrls: ['./bk-pill-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BkPillBadgeComponent {
  @Input() color: BkPillColor = 'neutral';

  get classes(): string {
    return `bk-pill bk-pill--${this.color}`;
  }
}
